<template>
  <div>
          <img src="../assets/loyykathong/kt.gif"/>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>